/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-dialog-error',
	templateUrl: './dialog-error.component.html',
	styleUrls: ['./dialog-error.component.scss']
})
export class DialogErrorComponent {

	constructor(
		public dialogRef: MatDialogRef<DialogErrorComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			error: ''
		}
	) { }

	onOkClick(): void {
		this.dialogRef.close(null);
	}

}
